import moment from "moment";
import { CustomerAPI } from "../api";
import Helper from "../plugins/Helper/Helper";
import i18n from '@/plugins/vue-i18n';

export class Customer {
  constructor(props) {
    this.id = props.objectId || "";
    this.contracts = props.contracts || [];
    this.objectId = props.objectId || "";
    this.erpId = props.erpId || "";
    this.internalId = props.internalId || "";
    this.type = props.type || "personal";
    this.title = props.title || "";
    // this.titleString = "";
    // if (i18n.te(`appeal_data.prefixName.${this.title}`)) {
    //   this.titleString = i18n.t(`appeal_data.prefixName.${this.title}`)
    // } else {
    //   this.titleString = this.title
    // }
    this.firstName = props.firstName || "";
    this.lastName = props.lastName || "";
    this.nickName = props.nickName || "";
    this.gender = props.gender || "";
    this.addressStreet = props.addressStreet || "";
    this.addressProvince = props.addressProvince || "";
    this.addressDistrict = props.addressDistrict || "";
    this.addressSubDistrict = props.addressSubDistrict || "";
    this.addressZipcode = props.addressZipcode || "";
    this.addressHouseStreet = props.addressHouseStreet || "";
    this.addressHouseProvince = props.addressHouseProvince || "";
    this.addressHouseDistrict = props.addressHouseDistrict || "";
    this.addressHouseSubDistrict = props.addressHouseSubDistrict || "";
    this.addressHouseZipcode = props.addressHouseZipcode || "";
    this.addressContactStreet = props.addressContactStreet || "";
    this.addressContactProvince = props.addressContactProvince || "";
    this.addressContactDistrict = props.addressContactDistrict || "";
    this.addressContactSubDistrict = props.addressContactSubDistrict || "";
    this.addressContactZipcode = props.addressContactZipcode || "";
    this.citizenId = props.citizenId || "";
    this.citizenCardIssueDate = props.citizenCardIssueDate ?.iso
      ? moment(props.citizenCardIssueDate ?.iso).format("YYYY-MM-DD")
      : null;
    this.citizenCardImages = props.citizenCardImages || [];
    this.citizenCardImages_tmp = props.citizenCardImages ?.map(i => i) || [];
    this.citizenCardLaserNo = props.citizenCardLaserNo || "";
    this.citizenCardExpiryDate = props.citizenCardExpiryDate ?.iso
      ? moment(props.citizenCardExpiryDate ?.iso).format("YYYY-MM-DD")
      : null;
    this.passportId = props.passportId || "";
    this.interTels = props.interTels || [""];
    this.tels = props.tels || [""];
    this.interTels_tmp = props.interTels?.length ? props.interTels.map(i => i || "") : [""];
    this.tels_tmp = props.tels?.length ? props.tels.map(i => i || "") : [""];
    this.emails_tmp = props.emails?.length ? props.emails.map(i => i || "") : [""];
    this.emails = props.emails || [""];
    this.website = props.website || "";
    this.lineIds = props.lineIds || [];
    this.facebook = props.facebook;
    this.instagram = props.instagram;
    this.lineId = props.lineId;
    this.youtube = props.youtube;
    this.tiktok = props.tiktok;
    this.educateLevel = props.educateLevel || "";
    this.educateLevelString = "";
    if (i18n.te(`education_level.${this.educateLevel}`)) {
      this.educateLevelString = i18n.t(`education_level.${this.educateLevel}`)
    } else {
      this.educateLevelString = this.educateLevel
    }
    this.companyName = props.companyName || "";
    this.companyBranchCode = props.companyBranchCode || "";
    this.companyBranchName = props.companyBranchName || "";
    this.businessName = props.businessName || "";
    this.marriageStatus = props.marriageStatus || "";
    this.marriageStatusString = "";
    if (i18n.te(`account.${this.marriageStatus}`)) {
      this.marriageStatusString = i18n.t(`account.${this.marriageStatus}`)
    } else {
      this.marriageStatusString = this.marriageStatus
    }
    this.marriageName = props.marriageName || "";
    this.nationality = props.nationality || "";
    this.nationalityString = "";
    if (i18n.te(`nationalities.${this.nationality}`)) {
      this.nationalityString = i18n.t(`nationalities.${this.nationality}`)
    } else {
      this.nationalityString = this.nationality
    }
    this.bankAccounts = props.bankAccounts ?.map(i => i) || [];
    this.profileImages = props.profileImages || [];
    this.profileImages_tmp = props.profileImages ?.map(i => i) || [];
    this.incomePerYear = props.incomePerYear || "";
    this.businessStartYear = props.businessStartYear || "";
    this.rentalStartYear = props.rentalStartYear || "";
    this.emergencyContactName = props.emergencyContactName || "";
    this.emergencyContactTel = props.emergencyContactTel || "";
    this.emergencyContactInterTel = props.emergencyContactInterTel || "";
    this.emergencyContactRelation = props.emergencyContactRelation || "";
    this.emergencyContactEmail = props.emergencyContactEmail || "";
    this.customerId = props.customerId || ""
    this.dateOfBirth = props.dateOfBirth ?.iso
      ? moment(props.dateOfBirth ?.iso).format("YYYY-MM-DD")
      : null;
    this.religion = props.religion || "";
    this.religionString = ""
    if (i18n.te(`religion.${this.religion}`)) {
      this.religionString = i18n.t(`religion.${this.religion}`)
    } else {
    this.religionString = this.religion
    }

    this.fullAddress = "";
    if (props.addressStreet) this.fullAddress += props.addressStreet + " ";
    if (props.addressSubDistrict) this.fullAddress += props.addressSubDistrict + " ";
    if (props.addressDistrict) this.fullAddress += props.addressDistrict + " ";
    if (props.addressProvince) this.fullAddress += props.addressProvince + " ";
    if (props.addressZipcode) this.fullAddress += props.addressZipcode;

    this.fullName = "";
    if (this.type == "personal") {
      if (props.title) this.fullName += props.title + " ";
      if (props.firstName) this.fullName += props.firstName + " ";
      if (props.lastName) this.fullName += props.lastName;
    } else if (this.type == "company") {
      if (props.companyName) this.fullName += props.companyName;
      // if (props.companyBranchName) this.fullNameLong += ` ${props.companyBranchName}`;
      // if (props.companyBranchName && props.companyBranchCode) this.fullNameLong += `(${props.companyBranchCode})`;
    }

    this.fullNameNoTitle = "";
    if (this.type == "personal") {
      if (props.firstName) this.fullNameNoTitle += props.firstName + " ";
      if (props.lastName) this.fullNameNoTitle += props.lastName;
    } else if (this.type == "company") {
      if (props.companyName) this.fullNameNoTitle += props.companyName;
      if (props.companyBranchName) this.fullNameNoTitle += ` ${props.companyBranchName}`;
      if (props.companyBranchName && props.companyBranchCode) this.fullNameNoTitle += `(${props.companyBranchCode})`;
    }

    this.fullTels = Helper.telToString(this.interTels, this.tels) || ''
    this.fullEmails = props.emails && props.emails.length ? props.emails.join(",") : ''

    this.labelSearch = `${this.fullNameNoTitle} ${this.fullTels} ${this.fullEmails} ${this.citizenId}`

    this.contractIds = this.contracts && this.contracts.length ? this.contracts.filter(ct => ct.isActive).map(ct => ct.contractId) : []

  }
  static async createCustomer(payload) {
    const { data } = await CustomerAPI.createCustomer(payload);
    return new Customer(data.result);
  }
  static async updateCustomer(payload) {
    const { data } = await CustomerAPI.updateCustomer(payload);
    return new Customer(data.result);
  }
  static async getCustomers(payload) {
    const { data } = await CustomerAPI.getCustomers(payload);
    return data.result.map(item => new Customer(item));
  }
  static async getCustomer(payload) {
    const { data } = await CustomerAPI.getCustomer(payload);
    return new Customer(data.result);
  }
  static async getCustomerByKeyword(payload) {
    const { data } = await CustomerAPI.getCustomerByKeyword(payload);
    return data.result.map(item => new Customer(item));
  }
  static async getCustomersByMarket(payload) {
    const { data } = await CustomerAPI.getCustomersByMarket(payload);
    return data.result.map(item => new Customer(item));
  }
  static async getCustomersByProject(projectId, limit, page, order) {
    const { data } = await CustomerAPI.getCustomersByProject(
      projectId,
      limit,
      page,
      order
    );
    return data.result.map(item => new Customer(item));
  }
  static async getCustomersLengthByProject(projectId) {
    const { data } = await CustomerAPI.getCustomersLengthByProject(projectId);
    return data.result;
  }
  static async getDuplicateCustomers(payload) {
    const { data } = await CustomerAPI.getDuplicateCustomers(payload);
    return data.result.map(item => new Customer(item));
  }

  static getBillingDataByCustomer(customerIn) {
    let billingData = {
      name: "",
      address: "",
      taxId: "",
      branchCode: "",
      branchName: "",
      tel: "",
      email: ""
    };
    if (customerIn) {
      const customer = {...customerIn}
      let fullName = "";
      // let fullAddress = "";
      // if (customer.addressStreet) fullAddress += customer.addressStreet + " ";
      // if (customer.addressSubDistrict) fullAddress += customer.addressSubDistrict + " ";
      // if (customer.addressDistrict) fullAddress += customer.addressDistrict + " ";
      // if (customer.addressProvince) fullAddress += customer.addressProvince + " ";
      // if (customer.addressZipcode) fullAddress += customer.addressZipcode;

      let fullAddress = `${customer.addressStreet || ''} ${customer.addressProvince == 'กรุงเทพมหานคร' ? "แขวง"
        : Helper.addressPrefix.subDistrict}${customer.addressSubDistrict || ''} ${customer.addressProvince == 'กรุงเทพมหานคร' ? "เขต"
          : Helper.addressPrefix.district}${customer.addressDistrict || ''} ${customer.addressProvince == 'กรุงเทพมหานคร' ? ""
            : Helper.addressPrefix.province}${customer.addressProvince || ''} ${customer.addressZipcode || ''}`;

      billingData.address = fullAddress;
      if (customer.citizenId) billingData.taxId = customer.citizenId;
      if (customer.tels) billingData.tel = Helper.telToString(customer.interTels, customer.tels);
      if (customer.emails) billingData.email = customer.emails.join();

      if (customer.type == 'personal') {
        if (customer.title) fullName += customer.title + " ";
        if (customer.firstName) fullName += customer.firstName + " ";
        if (customer.lastName) fullName += customer.lastName;
      } else if (customer.type == 'company') {
        if (customer.companyName) fullName = customer.companyName;
        if (customer.companyBranchCode) billingData.branchCode = customer.companyBranchCode;
        if (customer.companyBranchName) billingData.branchName = customer.companyBranchName;
      }
      billingData.name = fullName;
    }
    return billingData;
  }
  static getFullNameByCustomer(customer) {
    let fullName = "";
    if (customer) {
      if (customer.type == 'personal') {
        if (customer.title) fullName += customer.title + " ";
        if (customer.firstName) fullName += customer.firstName + " ";
        if (customer.lastName) fullName += customer.lastName;
      } else if (customer.type == 'company') {
        if (customer.companyName) fullName = customer.companyName;
      }
    }
    return fullName;
  }

  static async checkTaxID(payload) {
    const { data } = await CustomerAPI.checkTaxID(payload);
    return data.result;
  }

  static async getCustomerByIds(payload) {
    const { data } = await CustomerAPI.getCustomerByIds(payload);
    return data.result.map(item => new Customer(item));
  }
}
